export default {
  welcome: {
    textAlign: 'center',
    fontSize: 50,
    color: 'grey',
    paddingTop: 100,
    height: '100vh',
    backgroundImage: `url(/images/tile.png)`,
    backgroundRepeat: 'repeat',
  },
};



// WEBPACK FOOTER //
// ./src/components/Home/styles.js